var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 10,
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.6.2a1 1 0 0 1 .2 1.4l-6 8a1 1 0 0 1-1.507.107l-4-4a1 1 0 0 1 1.414-1.414l3.185 3.185L10.2.4a1 1 0 0 1 1.4-.2"
})));
export { SvgCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMCIgZmlsbD0iY3VycmVudENvbG9yIj4KICAgIDx0aXRsZT5DaGVja2VkPC90aXRsZT4KICAgIDxwYXRoIGQ9Ik0xMS42LjJhMSAxIDAgMCAxIC4yIDEuNGwtNiA4YTEgMSAwIDAgMS0xLjUwNy4xMDdsLTQtNGExIDEgMCAwIDEgMS40MTQtMS40MTRsMy4xODUgMy4xODVMMTAuMi40YTEgMSAwIDAgMSAxLjQtLjJaIi8+Cjwvc3ZnPg==";